import { formatISO, parseISO } from "date-fns";

import { serializerExtensions, SerializerExtensions } from "../extensions";
import { Serializer } from "../serializer";

export const dateOnly: Serializer<Date> & SerializerExtensions<Date> = {
  serialize: (value) => formatISO(value, { representation: "date" }),
  deserialize: parseISO,
  ...serializerExtensions(),
};

export const datetime: Serializer<Date> & SerializerExtensions<Date> = {
  serialize: (value) => value.toISOString(),
  deserialize: (raw) => new Date(raw),
  ...serializerExtensions(),
};
